// extracted by mini-css-extract-plugin
export default {"image":"FlightsInterlinkingItem-module__image___tKrra","text":"FlightsInterlinkingItem-module__text___AnHmJ"};